import { combineReducers } from "redux";
import loginReducer from "./Login/loginReducer";


const rootReducer = combineReducers({
  loginState: loginReducer,
  
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;

